import type { IconNode } from '../types';

/**
 * @name pond
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAzdjIiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iNyIgeD0iMTAiIHk9IjQiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik00IDEydjEwIiAvPgogIDxwYXRoIGQ9Ik0xMiAydjIiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iNyIgeD0iMiIgeT0iNSIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTEyIDExdjQuMzUiIC8+CiAgPHBhdGggZD0iTTE1IDE4LjVWMjJjLTMuOCAwLTctMS42LTctMy41czMuMi0zLjUgNy0zLjUgNyAxLjYgNyAzLjVjMCAxLjMtMS41IDIuNS0zLjkgMy4xWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/pond
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pond: IconNode = [
  ['path', { d: 'M4 3v2', key: '1mdgf8' }],
  ['rect', { width: '4', height: '7', x: '10', y: '4', rx: '2', key: '4npsrp' }],
  ['path', { d: 'M4 12v10', key: 'yw3kuv' }],
  ['path', { d: 'M12 2v2', key: 'tus03m' }],
  ['rect', { width: '4', height: '7', x: '2', y: '5', rx: '2', key: '1k95x3' }],
  ['path', { d: 'M12 11v4.35', key: '4r3wv2' }],
  [
    'path',
    {
      d: 'M15 18.5V22c-3.8 0-7-1.6-7-3.5s3.2-3.5 7-3.5 7 1.6 7 3.5c0 1.3-1.5 2.5-3.9 3.1Z',
      key: '1e38s7',
    },
  ],
];

export default pond;
